import { Chip, ChipSize, ChipVariant } from '@hourly-hds/components';

type UserStatus = 'Inactive' | 'Active';

const UserStatusChip = ({ status }: { status: UserStatus }) => {
  const variantMap: Record<UserStatus, ChipVariant | undefined> = {
    Inactive: undefined,
    Active: ChipVariant.Success,
  };

  return (
    <Chip size={ChipSize.Large} variant={variantMap[status]}>
      {status}
    </Chip>
  );
};

export default UserStatusChip;
